import { CHART_COLORS_BY_ACTIVITY } from "../../utils/constants/dashboard/dashboardModuleConstants";
import activityTypes from "../../utils/constants/activities/activitiesTypes";
import { CalendarActivityTypes } from "@customTypes/filter";

export const getCalendarActivityColors = (calendarActivityTypes: CalendarActivityTypes[]) =>
  calendarActivityTypes.map(
    (activityType: keyof typeof activityTypes) =>
      CHART_COLORS_BY_ACTIVITY[activityType as Exclude<CalendarActivityTypes, "ALL">]
  );
